/**
 * 认证服务模块
 * 提供用户登录、登出、Token管理等功能
 */
import apiClient from './api';

// localStorage 键名
const KEYS = {
  TOKEN: 'wifi_monitor_token',
  USER: 'wifi_monitor_user',
  DEVICE_IDS: 'wifi_monitor_device_ids',
};

// ============ 基础存储操作 ============

const getItem = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch {
    return null;
  }
};

const setItem = (key, value) => {
  if (value != null) {
    localStorage.setItem(key, JSON.stringify(value));
  } else {
    localStorage.removeItem(key);
  }
};

// ============ 认证相关 ============

/** 用户登录 */
export const login = async (username, password) => {
  try {
    const response = await apiClient.post('/auth/login', { username, password });
    if (response.data.code === 0) {
      const { token, user } = response.data.data;
      localStorage.setItem(KEYS.TOKEN, token);
      setItem(KEYS.USER, user);
      setItem(KEYS.DEVICE_IDS, user.device_ids?.length > 0 ? user.device_ids : null);
      return { success: true, user };
    }
    return { success: false, message: response.data.message || '登录失败' };
  } catch (error) {
    return { success: false, message: error.response?.data?.message || '登录失败，请稍后重试' };
  }
};

/** 用户登出 */
export const logout = () => clearAuth();

/** 清除认证信息 */
export const clearAuth = () => {
  Object.values(KEYS).forEach(key => localStorage.removeItem(key));
};

/** 检查是否已登录 */
export const isAuthenticated = () => !!localStorage.getItem(KEYS.TOKEN);

/** 获取当前用户 */
export const getCurrentUser = () => getItem(KEYS.USER);

/** 获取 Token */
export const getAuthToken = () => localStorage.getItem(KEYS.TOKEN);

// ============ 设备ID管理 ============

/** 获取用户设备ID列表 */
export const getUserDeviceIDs = () => getItem(KEYS.DEVICE_IDS);

/** 更新设备ID列表 */
export const updateUserDeviceIDs = (ids) => {
  setItem(KEYS.DEVICE_IDS, ids?.length > 0 ? ids : null);
};

/** 添加设备ID */
export const addUserDeviceID = (deviceId) => {
  const ids = getUserDeviceIDs() || [];
  if (!ids.includes(deviceId)) {
    updateUserDeviceIDs([...ids, deviceId]);
  }
};

/** 移除设备ID */
export const removeUserDeviceID = (deviceId) => {
  const ids = getUserDeviceIDs() || [];
  updateUserDeviceIDs(ids.filter(id => id !== deviceId));
};
